const translateAlt = {
  chinaFlag: 'Bendera China',
  malaysiaFlag: 'Malaysia Flag',
  britainFlag: 'Bendera Great Britain',
};

export default translateAlt;
